'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddIcCall = function AddIcCall(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M21.01 12.38C19.78 12.38 18.59 12.18 17.48 11.82C17.13 11.7 16.74 11.79 16.47 12.06L14.9 14.03C12.07 12.68 9.42 10.13 8.01 7.2L9.96 5.54C10.23 5.26 10.31 4.87 10.2 4.52C9.83 3.41 9.64 2.22 9.64 0.99C9.64 0.45 9.19 0 8.65 0H5.19C4.65 0 4 0.24 4 0.99C4 10.28 11.73 18 21.01 18C21.72 18 22 17.37 22 16.82V13.37C22 12.83 21.55 12.38 21.01 12.38Z"
  }), React__default["default"].createElement("path", {
    d: "M5 15V12H3V15H0V17H3V20H5V17H8V15H5Z"
  }));
};

var AddIcCall$1 = iconStyles()(AddIcCall);

module.exports = AddIcCall$1;
